<div class="host-zhenguo-sync-message">
  <div class="body">
    <i
      nz-icon
      nzType="question-circle"
      nzTheme="outline"
      class="icon"></i>
    <span class="title">是否开启美团民宿(榛果)的聊天同步？</span>
    <div class="content">
      <p>
        请您进入 渠道直连-添加渠道账号，将所有的美团民宿(榛果)账号重新添加一次，即可打开聊天同步。
      </p>

      <p>您的操作不会造成数据重复或其他影响。</p>
      <label
        nz-checkbox
        [(ngModel)]="checked"
        class="checkbox">
        不再提醒
      </label>
    </div>
  </div>
  <div class="footer">
    <button
      nz-button
      (click)="onCancel()">
      暂不设置
    </button>
    <button
      nz-button
      nzType="primary"
      (click)="onConfirm()">
      去设置
    </button>
  </div>
</div>
